import createIcon from '../../createIcon';

/**
 * @component @name Rotate90DegreesCw
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC4xNCAxOS44NjhDNy4xNyAyMi44OTggMTEuODEgMjMuMzA4IDE1LjI5IDIxLjExOEwxMy44MyAxOS42NThDMTEuMTcgMjEuMDg4IDcuNzkgMjAuNjg4IDUuNTUgMTguNDQ4QzIuODIgMTUuNzE4IDIuODIgMTEuMjc4IDUuNTUgOC41NDgwNUM2LjkyIDcuMTg4MDUgOC43MSA2LjUyODA1IDEwLjUgNi41MjgwNVY5LjQ5ODA1TDE0LjUgNS40OTgwNUwxMC41IDEuNDk4MDVWNC41MDgwNUM4LjIgNC41MDgwNSA1Ljg5IDUuMzc4MDUgNC4xNCA3LjEzODA1QzAuNjIgMTAuNjQ4IDAuNjIgMTYuMzQ4IDQuMTQgMTkuODY4Wk0xMC41IDEzLjQ5OEwxNi41IDE5LjQ5OEwyMi41IDEzLjQ5OEwxNi41IDcuNDk4MDVMMTAuNSAxMy40OThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Rotate90DegreesCw = createIcon('Rotate90DegreesCw', [
  [
    'path',
    {
      d: 'M4.14 19.868C7.17 22.898 11.81 23.308 15.29 21.118L13.83 19.658C11.17 21.088 7.79 20.688 5.55 18.448C2.82 15.718 2.82 11.278 5.55 8.54805C6.92 7.18805 8.71 6.52805 10.5 6.52805V9.49805L14.5 5.49805L10.5 1.49805V4.50805C8.2 4.50805 5.89 5.37805 4.14 7.13805C0.62 10.648 0.62 16.348 4.14 19.868ZM10.5 13.498L16.5 19.498L22.5 13.498L16.5 7.49805L10.5 13.498Z',
      key: 'zxvi1m',
    },
  ],
]);

export default Rotate90DegreesCw;
